if (!customElements.get('product-form')) {

  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      const idInput = this.form.querySelector('[name=id]');
      const cardQuickadd = this.closest('[js-card-quickadd]');
      if (idInput) {
        if (cardQuickadd && !idInput.value) {
          idInput.disabled = true;
        } else {
          idInput.disabled = false;
        }
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }



    // This is the submit button function
    onSubmitHandler(evt) {
      evt.preventDefault();

      // Source - https://stackoverflow.com/a
      // Posted by Neri
      // Retrieved 2025-12-23, License - CC BY-SA 3.0

      const hasSizeInForm = this.form.querySelector('input[name="Size"]');
      const hasAmountInForm = this.form.querySelector('input[name="Amount"]');
      if (hasSizeInForm || hasAmountInForm) {
        const checked_size = hasSizeInForm ? this.form.querySelector('input[name="Size"]:checked') : null;
        const checked_amount = hasAmountInForm ? this.form.querySelector('input[name="Amount"]:checked') : null;
        if (!checked_size && !checked_amount) {
          if (hasSizeInForm) {
            this.handleErrorMessage('Please select a size.');
          } else if (hasAmountInForm) {
            this.handleErrorMessage('Please select an amount.');
          }
          const variantContainer = document.querySelector('.product-form__input--variants');
          if (variantContainer) variantContainer.classList.add('is-error');
          return;
        }
      }

      const idField = this.form.querySelector('[name=id]');
      if (this.closest('[js-card-quickadd]') && idField && !idField.value) {
        return;
      }


      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            console.log("down here");
            // window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          this.dispatchEvent(new CustomEvent('product-form:cart-success', { bubbles: true }));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      document.querySelector('.product-form__input--variants')?.classList.remove('is-error');

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
